import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
  IconButton,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { useDispatch } from "react-redux";
import Loader from "@icarius-common/loader";
import { modifyFieldOptionAction } from "@icarius-pages/catalogs/actions";
import useHandleForm from "./useHandleForm";
import DeleteIcon from "@material-ui/icons/Delete";

const gridStyle = { height: 75, padding: "10px 0px" };

const CreateModifyTableDialog = (props) => {

  const {
    open,
    isLoading,
    data,
    handleClose,
  } = props;

  const dispatch = useDispatch();

  const modify = (dataToSend) => {
    const filteredData = dataToSend.optionList.filter(option => option.key.trim() !== "" && option.value.trim() !== "");
    dispatch(modifyFieldOptionAction({ tableCode: data.physicalCode, fieldCode: data.fieldCode, optionList: filteredData }))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    formData,
    setFormValue,
    submit,
    handleAddOption,
    handleDeleteOption,
  } = useHandleForm(data, modify, openValidationError);

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("validValuesList")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Loader open={isLoading} />
          <Grid container item xs={12}>
            {
              formData.optionList.map((item, index) => (
                <Grid
                  container
                  spacing={1}
                  alignItems="center"
                  key={index}
                  style={gridStyle}
                >
                  <Grid item xs={5}>
                    <TextField
                      label={getLocalizedString("codeShort")}
                      value={item.key}
                      onChange={(e) =>
                        setFormValue(index, "key", e.target.value)
                      }
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={5}>
                    <TextField
                      label={getLocalizedString("name")}
                      value={item.value}
                      onChange={(e) =>
                        setFormValue(index, "value", e.target.value)
                      }
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={2}>
                    {
                      formData.optionList.length > 1 &&
                      <IconButton
                        onClick={() => handleDeleteOption(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    }
                  </Grid>
                </Grid>
              ))}

            <Button
              className="whiteText"
              variant="contained"
              onClick={handleAddOption}
            >
              {getLocalizedString("addOption")}
            </Button>
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
          <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div >
    </Dialog >
  );
}

export default CreateModifyTableDialog;